<template>
    <div class="security">
        
        <h2 :style="{ marginBottom: '16px' }">
            安全设置
        </h2>
        <a-list item-layout="horizontal">
            <a-list-item>
                <a slot="actions" @click="showeditpwd">修改</a>
                <a-list-item-meta description="******">
                    <a slot="title" href="javascript:;">登录密码</a>
                </a-list-item-meta>
            </a-list-item>
            <a-list-item style="border-bottom:none">
                <a slot="actions" @click="showeditphone">绑定</a>
                <a-list-item-meta description="尚未绑定手机号码">
                    <a slot="title" href="javascript:;">手机号</a>
                </a-list-item-meta>
            </a-list-item>
            <span style="color: rgba(0, 0, 0, 0.45);font-size: 14px;">绑定的手机号可以用于登录飞象宝后台。</span>
        </a-list>

        <a-modal
        class="pwdmodal"
        title="修改密码"
        cancelText="取消"
        okText="确定"
        width="600px"
        :visible="pwdmodal"
        :confirm-loading="confirmLoading"
        @ok="pwdedit"
        @cancel="handleCancel"
        >
            <!-- <a-row>
                <a-col :span="5">
                    <label class="required-icon">旧密码：</label>
                </a-col>
                <a-col :span="16">
                    <a-input type="password" placeholder="请输入旧密码"></a-input>
                </a-col>
            </a-row> -->
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">新密码：</label>
                </a-col>
                <a-col :span="16">
                    <a-input type="password" v-model="password" placeholder="请输入新密码"></a-input>
                </a-col>
            </a-row>
            <!-- <a-row>
                <a-col :span="5">
                    <label class="required-icon">确认新密码：</label>
                </a-col>
                <a-col :span="16">
                    <a-input type="password" v-model="repassword" placeholder="请确认新密码"></a-input>
                </a-col>
            </a-row> -->
        </a-modal>

        <a-modal
        class="pwdmodal"
        title="绑定手机"
        cancelText="取消"
        okText="确定"
        width="520px"
        :visible="phonemodal"
        :confirm-loading="confirmLoading"
        @ok="phoneedit"
        @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">手机号：</label>
                </a-col>
                <a-col :span="16">
                    <a-input placeholder="请输入手机号"></a-input>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">验证码：</label>
                </a-col>
                <a-col :span="16" style="display:flex">
                    <a-input placeholder="请输入验证码"></a-input>
                    <a-button style="margin-left:10px">获取验证码</a-button>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
export default {
    data(){
        return{
            pwdmodal:false,
            phonemodal:false,
            confirmLoading:false,
            password:"",
            repassword:""
        }
    },
    methods:{
        showeditpwd(){
            this.pwdmodal=true
        },
        showeditphone(){
            this.phonemodal=true
        },
        handleCancel(e) {
            this.pwdmodal = false;
            this.phonemodal = false;
        },
        pwdedit(){
            var params=new URLSearchParams()
            params.append('password',this.password)
            this.$axios.post('/api/changepassword',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('修改成功');
                    this.pwdmodal=false
                }else if(res.data.code==300){
                    this.$message.success('请重新登录');
                    setTimeout(() => {
                        this.$router.push({path: '/'})
                    }, 2000);
                }
            })
        },
        phoneedit(){
            
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/security/index.vue